import React, { useCallback, useState } from "react";

/**
 * A custom hook that provides state management and utilities for handling a popover component. In case popover is
 * rendered outside of the viewport, it will automatically adjust its position.
 */
export const usePopoverState = (onBlur?: (event: any) => void) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleToggleOpen = useCallback<React.MouseEventHandler<HTMLDivElement | HTMLButtonElement>>(
    (event) => {
      setOpen((prev) => {
        if (prev) {
          onBlur?.(event);
        }
        return !prev;
      });
    },
    [onBlur]
  );

  const handleClickAway = useCallback<(event: MouseEvent | TouchEvent) => void>(
    (event) => {
      if (open) {
        setOpen(false);
        onBlur?.(event);
      }
    },
    [open, onBlur]
  );

  return {
    open,
    anchorEl,
    setAnchorEl,
    handleToggleOpen,
    handleClickAway,
  };
};
